var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWork(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.208,
    y: 11.282,
    width: 20.583,
    height: 9.247,
    rx: 0.3,
    fill: "#B07B34"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.208 6.986a.3.3 0 01.3-.3h19.984a.3.3 0 01.3.3v8.98s-4.245 1.146-10.292 1.146-10.292-1.146-10.292-1.146v-8.98z",
    fill: "#A5722F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.78 5.88a.3.3 0 01.3-.3h20.84a.3.3 0 01.3.3v8.594a.482.482 0 01-.373.476c-1.19.269-5.123 1.057-10.347 1.057-5.224 0-9.157-.788-10.347-1.057a.482.482 0 01-.374-.476V5.881z",
    fill: "#BF8E54"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD15C",
    d: "M11.375 13.736h2.251v3.376h-2.251z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFBF1B",
    d: "M11.375 15.986h2.251v1.125h-2.251z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.767 5.58V4.472a1 1 0 011-1h9.466a1 1 0 011 1v1.11",
    stroke: "#B07B34",
    strokeWidth: 1.2
  })));
}
export default SvgWork;